import React from 'react'
import { Layout } from 'antd'

export default function Box ({ children }) {
  const { Content } = Layout

  return (
    <Layout className='layout' style={{ margin: '50px' }}>
      <Content style={{ padding: '20px 50px' }}>{children}</Content>
    </Layout>
  )
}
